(function () {
  /* Friendly message when Shopify refuses an add (usually: last pair in that size is already in the bag) */
  window.MSaddError = function (j) {
    var d = String((j && (j.description || j.message)) || '');
    if (/sold out|can.t add|cannot add|already|maximum|max|not enough|only|all \d+/i.test(d) || (j && j.status === 422))
      return 'The last pair in that size is already in your bag. Please choose another size or style.';
    return 'Sorry, that pair could not be added. Please try again.';
  };
  function $(s, r) { return (r || document).querySelector(s); }
  /* Clearer pair-offer wording everywhere the progress box appears */
  var base = window.MStier;
  function tier(root, count) {
    if (!root) return;
    if (base) base(root, count);
    var msg = count <= 0 ? 'Choose your first pair to begin.'
      : count === 1 ? 'Add a second pair — get 20% off.'
      : count === 2 ? 'Add a third pair — get 30% off.'
      : 'Your best price is unlocked.';
    var next = count <= 1 ? 'Next: your second pair is 20% off'
      : count === 2 ? 'Next: your third pair is 30% off'
      : 'Second pair 20% off · third pair 30% off';
    var m = $('[data-tier-msg]', root); if (m) m.textContent = msg;
    var n = $('[data-tier-next]', root); if (n) n.textContent = next;
  }
  window.MStier = tier;
  document.querySelectorAll('[data-tier]').forEach(function (el) { tier(el, parseInt(el.getAttribute('data-tier'), 10) || 0); });

  /* Bag: "Yes, show me" reveals a few pairs to add */
  var yes = $('[data-offer-yes]'), more = $('[data-offer-more]');
  if (yes && more) {
    yes.addEventListener('click', function () {
      var open = more.hasAttribute('hidden');
      if (open) more.removeAttribute('hidden'); else more.setAttribute('hidden', '');
      yes.setAttribute('aria-expanded', open ? 'true' : 'false');
      yes.textContent = open ? 'Hide' : 'Yes, show me';
    });
  }
  /* Bag: gift note flag */
  var note = $('[data-gift-note]'), flag = $('[data-gift-flag]');
  if (note && flag) {
    var sync = function () { flag.value = note.value.trim() ? 'Yes' : ''; };
    note.addEventListener('input', sync); sync();
  }
})();

/* Shop drop-down + phone menu */
(function () {
  var shops = document.querySelectorAll('[data-menu-shop]'), mega = document.getElementById('ms-mega');
  var hoverable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var t = null;
  function place() { var h = document.querySelector('.ms-wrap>header'); if (!h || !mega) return; var r = h.getBoundingClientRect(); mega.style.top = (r.bottom + window.scrollY) + 'px'; }
  function open() { if (!mega) return; clearTimeout(t); place(); mega.hidden = false; shops.forEach(function (s) { s.setAttribute('aria-expanded', 'true'); }); }
  function close() { if (!mega) return; clearTimeout(t); mega.hidden = true; shops.forEach(function (s) { s.setAttribute('aria-expanded', 'false'); }); }
  function later() { clearTimeout(t); t = setTimeout(close, 180); }
  shops.forEach(function (s) {
    if (hoverable) { s.addEventListener('mouseenter', open); s.addEventListener('mouseleave', later); }
    s.addEventListener('click', function (e) { if (!hoverable && mega && mega.hidden && window.innerWidth > 760) { e.preventDefault(); open(); } });
    s.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); open(); var f = mega && mega.querySelector('a'); if (f) f.focus(); } });
  });
  if (mega) {
    mega.addEventListener('mouseenter', function () { clearTimeout(t); });
    mega.addEventListener('mouseleave', later);
    mega.addEventListener('focusout', function (e) { if (!mega.contains(e.relatedTarget)) later(); });
    mega.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
  }
  document.addEventListener('click', function (e) { if (mega && !mega.hidden && !mega.contains(e.target) && !e.target.closest('[data-menu-shop]')) close(); });
  window.addEventListener('resize', function () { if (mega && !mega.hidden) place(); });

  var drawer = document.getElementById('ms-drawer'), burgers = document.querySelectorAll('[data-menu-open]');
  function dOpen() { if (!drawer) return; drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); var x = drawer.querySelector('[data-menu-close]'); if (x) x.focus(); }
  function dClose() { if (!drawer) return; drawer.hidden = true; document.documentElement.style.overflow = ''; burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  burgers.forEach(function (b) { b.addEventListener('click', dOpen); });
  if (drawer) drawer.querySelectorAll('[data-menu-close],[data-menu-go]').forEach(function (el) { el.addEventListener('click', dClose); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); dClose(); } });

  /* Home: ?g=men / ?g=women opens the grid already filtered */
  var g = new URLSearchParams(location.search).get('g');
  if (g) { var fb = document.querySelector('[data-filter="' + g + '"]'); if (fb) fb.click(); }
})();
